export default __webpack_public_path__ + "static/media/uipath-logo.7fd498fb.svg";